import { render, staticRenderFns } from "./ImportApprove.vue?vue&type=template&id=83e053ac&scoped=true&"
import script from "./ImportApprove.vue?vue&type=script&lang=js&"
export * from "./ImportApprove.vue?vue&type=script&lang=js&"
import style0 from "./ImportApprove.vue?vue&type=style&index=0&id=83e053ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e053ac",
  null
  
)

export default component.exports